import React, { useState } from "react";
import { Box, Flex, Text, Divider } from "@chakra-ui/react";
import { useSelector } from "react-redux";

const PERIODS = [
  { key: "weekly", label: "Weekly" },
  { key: "monthly", label: "Monthly" },
  { key: "yearly", label: "Yearly" },
];

export const ExpensesCard = ({ expensesData, pageColor: pageColorProp }) => {
  const fallbackDisplayData = useSelector(
    (state) => state?.switchTab?.currentDisplay?.dashboard?.expenses,
  );
  const displayData = expensesData || fallbackDisplayData || {};
  const { cost, total, totalExpenses, avgUsage } = displayData;

  const fallbackPageColor = useSelector(
    (state) => state?.switchTab?.brandColor?.brandColor,
  );
  const pageColor = pageColorProp || fallbackPageColor;

  const [period, setPeriod] = useState("monthly");
  const avg = avgUsage?.[period] || { value: "0", unit: "" };
  const periodLabel =
    period === "weekly" ? "week" : period === "monthly" ? "month" : "year";

  return (
    <Box p="20px" h="100%">
      {/* Header + period pills */}
      <Flex
        justify="space-between"
        align="center"
        mb={4}
        flexWrap="wrap"
        gap={2}
      >
        <Text fontSize="22px" fontWeight="bold">
          Avg Usage
        </Text>
        <Flex gap={2}>
          {PERIODS.map(({ key, label }) => (
            <Box
              key={key}
              bg={period === key ? pageColor : "#fff"}
              color={period === key ? "#fff" : pageColor}
              border={`1px solid ${pageColor}`}
              borderRadius="5px"
              fontSize="12px"
              fontWeight="medium"
              py="5px"
              px="10px"
              cursor="pointer"
              onClick={() => setPeriod(key)}
            >
              {label}
            </Box>
          ))}
        </Flex>
      </Flex>

      {/* Big average stat */}
      <Flex direction="column" align="center" justify="center" py={5}>
        <Flex alignItems="baseline" gap="2px">
          <Text
            fontSize="44px"
            fontWeight="bold"
            color={pageColor}
            lineHeight="1"
          >
            {avg.value}
          </Text>
          <Text
            fontSize="16px"
            fontWeight="600"
            color="gray.500"
            lineHeight="1"
            ml={1}
          >
            {avg.unit}
          </Text>
        </Flex>
        <Text fontSize="13px" color="gray.400" mt={2}>
          average per {periodLabel}
        </Text>
      </Flex>

      <Divider my={3} />

      {/* Summary stats */}
      <Flex justify="space-between" fontSize="13px" mt={2}>
        <Box textAlign="center">
          <Text color="gray.400" fontWeight="semibold">
            {total?.tag || "Total"}
          </Text>
          <Text fontWeight="bold">{total?.amount || "—"}</Text>
        </Box>
        <Box textAlign="center">
          <Text color="gray.400" fontWeight="semibold">
            Total Spent
          </Text>
          <Text fontWeight="bold" color={pageColor}>
            {totalExpenses?.amount || "—"}
          </Text>
        </Box>
        <Box textAlign="center">
          <Text color="gray.400" fontWeight="semibold">
            Last Bill
          </Text>
          <Text fontWeight="bold">{cost?.amount || "—"}</Text>
        </Box>
      </Flex>
    </Box>
  );
};
